/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseContainerFragment, ContainerFragment, FullContainerFragment} from '@amblique/contentful/app/contentful/fragments/container';

/**
 * Get a single Container by ID (base - scalars only)
 */
export const getBaseContainerById = gql`
  ${BaseContainerFragment}

  query GetBaseContainerById($id: String!, $locale: String!, $preview: Boolean) {
    container(id: $id, locale: $locale, preview: $preview) {
      ...BaseContainerFragment
    }
  }
`;

/**
 * Get a single Container by ID (standard - 1 level deep)
 */
export const getContainerById = gql`
  ${ContainerFragment}

  query GetContainerById($id: String!, $locale: String!, $preview: Boolean) {
    container(id: $id, locale: $locale, preview: $preview) {
      ...ContainerFragment
    }
  }
`;

/**
 * Get a single Container by ID (full - 2 levels deep)
 */
export const getFullContainerById = gql`
  ${FullContainerFragment}

  query GetFullContainerById($id: String!, $locale: String!, $preview: Boolean) {
    container(id: $id, locale: $locale, preview: $preview) {
      ...FullContainerFragment
    }
  }
`;

/**
 * Get all Container entries with pagination (base - scalars only)
 */
export const getBaseContainers = gql`
  ${BaseContainerFragment}

  query GetBaseContainers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ContainerOrder]
    $where: ContainerFilter
    $preview: Boolean
  ) {
    containerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseContainerFragment
      }
    }
  }
`;

/**
 * Get all Container entries with pagination (standard - 1 level deep)
 */
export const getContainers = gql`
  ${ContainerFragment}

  query GetContainers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ContainerOrder]
    $where: ContainerFilter
    $preview: Boolean
  ) {
    containerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ContainerFragment
      }
    }
  }
`;

/**
 * Get all Container entries with pagination (full - 2 levels deep)
 */
export const getFullContainers = gql`
  ${FullContainerFragment}

  query GetFullContainers(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ContainerOrder]
    $where: ContainerFilter
    $preview: Boolean
  ) {
    containerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullContainerFragment
      }
    }
  }
`;
